<script setup lang="ts">
import { ReferencingObjectDto } from '@/api/generator';
import OverviewTable from '@/components/OverviewTable/OverviewTable.vue';
import OverviewTableHeader from '@/components/OverviewTable/OverviewTableHeader.vue';
import IdentifierLabel from '@/components/IdentifierLabel/IdentifierLabel.vue';
import { useTranslation } from 'i18next-vue';
import { I18nKey } from '@/utils/typings';

type EntityReferencesModalProps = {
  title: string;
  references?: ReferencingObjectDto[] | null;
};

const { t } = useTranslation();

const headers = [
  {
    title: '',
    key: 'entityName',
    sortable: true,
  },
  {
    title: t('EntityType'),
    key: 'entityTypeName',
    sortable: true,
  },
] as const;

defineProps<EntityReferencesModalProps>();
</script>

<template>
  <OverviewTable
    class="entity-references-table"
    :headers="headers"
    itemLabel="Entity"
    data-testid="DataTable_EntityReferences"
    :zebra="true"
    :noSpacing="true"
    :items="references || undefined"
    fixedHeader
  >
    <template #header.entityName="headerProps">
      <OverviewTableHeader v-bind="headerProps">
        {{ $t('Name') }}
        <span class="font-weight-medium">| {{ $t('ID') }}</span>
      </OverviewTableHeader>
    </template>
    <template #item.entityName="{ item }">
      <IdentifierLabel :identifier="item.iuid" :label="item.entityName" />
    </template>
    <template #item.entityTypeName="{ item }">
      {{ $t(item.entityTypeName as I18nKey) }}
    </template>
  </OverviewTable>
</template>

<style scoped lang="scss">
// ponytail: leftover viewport after dialog title/actions; flex-fill the card if the description starts clipping
.entity-references-table :deep(.v-table__wrapper) {
  max-height: calc(100dvh - 32rem);
}
</style>
